import React from 'react';
import Button, { ButtonProps } from '../button/button.component';

interface Props extends Omit<ButtonProps, 'children'> {}

const IconButton = React.forwardRef<HTMLButtonElement, Props>((props, ref) => (
  <Button
    ref={ref}
    {...props}
  />
));

export default IconButton;
